import { render, staticRenderFns } from "./SessionViewUserPermissionsCard.vue?vue&type=template&id=52040929&scoped=true&"
import script from "./SessionViewUserPermissionsCard.vue?vue&type=script&lang=js&"
export * from "./SessionViewUserPermissionsCard.vue?vue&type=script&lang=js&"
import style0 from "./SessionViewUserPermissionsCard.vue?vue&type=style&index=0&id=52040929&lang=scss&scoped=true&"
import style1 from "./SessionViewUserPermissionsCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52040929",
  null
  
)

export default component.exports